import FuelSelector from './components/FuelSelector';
import {MessageBanner} from '../messagebanner/MessageBanner';
import {LOCALSTORAGE_TCSAPP_PREFIX_KEY} from './BannerStateStorage';
import {useTranslation} from 'react-i18next';
import MMap from "./MMap";

const GMapLoader = () => {
    const {t} = useTranslation();

    return (
        <>
            <MessageBanner advertBanners={[
                {
                    localStorageKey: LOCALSTORAGE_TCSAPP_PREFIX_KEY,
                    minDate: new Date("2026-04-01T00:00:01+02:00"),
                    maxDate: new Date("2026-12-31T23:59:59+01:00"),
                    title: t('TcsApp_Banner_Title'),
                    description: t('TcsApp_Banner_Description'),
                    severity: "info",
                    url: t('TcsApp_Banner_Url')
                }
            ]}/>
            <MMap/>
            <FuelSelector/>
        </>
    )
}

export default GMapLoader
